/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class NotificationMessageResponse {
    getFixupPrototypeFunction() { return NotificationMessageResponse.fixupPrototype; }

    static newInstance(model: Partial<NotificationMessageResponse>): NotificationMessageResponse {
        let obj = Object.assign(new NotificationMessageResponse(), model);
        NotificationMessageResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<NotificationMessageResponse>): NotificationMessageResponse {
        if (!model) return null;
        return NotificationMessageResponse.newInstance(<NotificationMessageResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: NotificationMessageResponse) {
        if (!obj) return;

        models.NotificationMessageResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: NotificationMessageResponse): boolean {
        Object.setPrototypeOf(obj, NotificationMessageResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Status of the notification & message api
     */
    status: string;

    /**
     * Message of the notification & message api
     */
    message: string;

    /**
     * data for the notification & message api
     */
    data: any;

}
